import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI'
import { ExpenseStateClass } from './interfaces/expenseStateClass';
import { submittedTimesheetAsync } from '../timesheet/timesheetSlice';
import { updateIsDisabledAsync } from '../admin/customFields/CustomFieldSlice';

const initialState: ExpenseStateClass = {
    isLoading: true,
    isCanvasLoading: false,
    status: 'idle',
    AccountEmployeeId: 0,
    expenseSheetList: [],
    expenseEntryList: [],
    filteredExpenseEntryList: [],
    expenseSheetMasterList: [],
    expensePerdiemList: [],
    expenseSheetApprovalList: [],
    MasterData: [],
    TotalExpenseAmount: 0,
    CurrencySymbol: '',
    DetailsData: [],
    SheetDetailForCalculation: [],
    ReimburseCurrency: [],
    ExchangeRate: 0,
    selectedRecord: {},
    isReload: false,
    optionEmployeeNameValue: "0",
    optionEmployeeNameText: "All",
    AccountExpenseEntryId: 0,
    perDiemData: [],
    perDiemType: [],
    perDiemLocationRate: [],
    employeeList: [],
    reimbursecurrencyList: [],
    isEdit: 0,
    AccountExpensePolicyPerDiemLocationId: 0,
    AccountEmployeeExpenseSheetId: '',
    MasterEmployeeExpenseSheetId: '',
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    expensesheetDate: new Date().toISOString(),
    accountCurrencyId:0,
    reimburseCurrencyId: 0,
    expenseSheetDescription: '',
    currentPage:1,
    pageSize:10,
    IsValidatePerDiemPolicy:[],
    IsSheetSubmitted:'',
    IsDescriptionPopup:true,
    LockSubmittedRecord:false,
    LockApprovedRecord:false,
    DecimalPlaces:2,
    ImageURL:'',
    LogoURL:'',
    IsElectronicSignExistInSessionAccount:false,
    LockAllPreviousExpenseEntries:false,
    LockAllPreviousMonthsExpenseEntries:false,
    LockButton:false,
    SheetSubmitted:false,
    SheetApproved:false,
    sortOrderExpenseSheet:'desc', 
    sortColumnExpenseSheet:'ExpenseSheetDate',
    approvalStatus: false,
    loadClient: false

}
interface IThunkApi {
    state: {
        expense: ExpenseStateClass;
        globalState: any;
    },
}

export const getEmployeeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'expense/getEmployee',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetAccountEmployeesForExpenseSheet', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }

    )

export const getReimburseCurrencyAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'expense/getReimburseCurrency',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetCurrencyData/' + 0, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }

    )


export const getExpenseSheetByAccountEmployeeIdAsync = createAsyncThunk
<any, any, IThunkApi>(
    'expense/getExpenseSheetByAccountEmployeeId',
    async (arg, thunkApi) => {
        const { AccountEmployeeId } = arg;
        const { ExpenseSheetStatusId } = arg;
        const { IncludeDateRange } = arg;
        const { StartDate } = arg;
        const { EndDate } = arg;
        const { AmountCondition } = arg; 
        const { Amount } = arg;         

        let url = 'api/V2/ExpenseSheets/GetExpenseSheetByAccountEmployeeId/' + AccountEmployeeId + '/' +  ExpenseSheetStatusId + '/' + IncludeDateRange + '/' +  StartDate + '/' +  EndDate;
        const queryParams: string[] = [];

        if (AmountCondition) {
            queryParams.push('AmountCondition=' + encodeURIComponent(AmountCondition));
        }
        
        if (Amount !== null && Amount !== undefined && Amount !== '') {
            queryParams.push('Amount=' + encodeURIComponent(Amount));
        }

        if (queryParams.length > 0) {
            url = url + '?' + queryParams.join('&');
        }

        const response = await fetchAPI(url, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
        const json = await response.json();
        return json;
    }
);


export const getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetId/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getExpenseEntriesByAccountEmployeeExpenseSheetId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetExpenseEntriesByAccountEmployeeExpenseSheetId/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const getCalculationsFieldsByAccountExpenseIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getCalculationsFieldsByAccountExpenseId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetCalculationsFieldsByAccountExpenseId/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const SetDefaultExpenseRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/SetDefaultExpenseRate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/SetDefaultExpenseRate/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const getCalculateAmountAndReimburseAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getCalculateAmountAndReimburseId',
        async (arg, thunkApi) => {
            const { AccountEmployeeExpenseSheetId } = arg;
            const { ReimbursementCurrencyId } = arg;
            const { ExpenseSheetDate } = arg;
            const response = await fetchAPI('api/V2/ExpenseSheets/GetCalculateAmountAndReimburse/' + AccountEmployeeExpenseSheetId + '/' + ReimbursementCurrencyId + '/' + ExpenseSheetDate, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const getExpenseSheetTotalAmountAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getExpenseSheetTotalAmount',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetExpenseSheetTotalAmount/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const getDataByAccountExpenseEntryIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getDataByAccountExpenseEntryIdAsync',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetDataAccountExpenseEntriesByAccountExpenseEntryId/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const GetEmployeeExpenseSheetApprovalDetailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetEmployeeExpenseSheetApprovalDetail',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetEmployeeExpenseSheetApprovalDetail/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const GetSubmittedByAndSubmittedOnAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetSubmittedByAndSubmittedOn',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetSubmittedByAndSubmittedOn/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const GetExpenseCalculateAmountAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetExpenseCalculateAmount',
        async (arg, thunkApi) => {
            const { ExpenseId } = arg;
            const { taxZoneId } = arg;
            const { netAmount } = arg;
            const { amount } = arg;
            const { isUserChanged } = arg;
            const { isUserTaxAmount } = arg;
            const { isChangedNetAmount } = arg;
            const { quantity } = arg;
            const { rate } = arg;
            const { parsedQuantity } = arg;
            const { parsedRate } = arg;
            const { parsedAmount } = arg;
            const { parsedNetAmount } = arg;
            const { parsedTaxAmount } = arg;
            // const response = await fetchAPI('api/V2/Expenses/GetExpenseCalculateAmount/' + ExpenseId + '/' + taxZoneId + '/' + parsedNetAmount + '/' + parsedAmount + '/' + isUserChanged + '/' + isUserTaxAmount + '/' + isChangedNetAmount + '/' + parsedQuantity + '/' + parsedRate + '/' + parsedTaxAmount, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const response = await fetchAPI(`api/V2/Expenses/GetExpenseCalculateAmount/${ExpenseId}/${taxZoneId}/${parsedNetAmount}/${parsedAmount}/${isUserChanged}/${isUserTaxAmount}/${isChangedNetAmount}?Quantity=${parsedQuantity}&Rate=${parsedRate}&TaxAmount=${parsedTaxAmount}`, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const GetDataForExpenseSheetPrintAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetDataForExpenseSheetPrint',
        async (arg, thunkApi) => {
            const { AccountEmployeeExpenseSheetId } = arg;
            const { isCompanyOwnLogo } = thunkApi.getState().globalState;
            const response = await fetchAPI('api/V2/Expenses/GetDataForExpenseSheetPrint/' + arg + '/' + 0 + '/' + 0 + '/' + isCompanyOwnLogo, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const getAccountExpensePerDiemTypeAndRateAsyc = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/getAccountExpensePerDiemTypeAndRate',
        async (arg, thunkApi) => {
            const { AccountEmployeeId } = arg;
            const { AccountExpensePolicyPerDiemLocationId } = arg;
            const { StartDate } = arg;
            const { EndDate } = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/GetAccountExpensePerDiemTypeAndRate/' + AccountEmployeeId + '/' + AccountExpensePolicyPerDiemLocationId + '/' + StartDate + '/' + EndDate, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )

export const getValidateAccountExpensePolicyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetValidateAccountExpensePolicy',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpensePolicies/GetValidateAccountExpensePolicy/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )   

    
    export const getDataForLockExpensePreviuosEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/GetDataForLockExpensePreviuosEntries',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetDataForLockExpensePreviuosEntries/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    ) 


export const ShowExpenseSheetStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/ShowExpenseSheetStatus',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/ShowExpenseSheetStatus/' + arg, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
            const json = await response.json();
            return json;
        }
    )


export const addAccountEmployeeExpenseSheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/addAccountEmployeeExpenseSheet',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpenseSheets/InsertAccountEmployeeExpenseSheet/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const addAccountExpenseEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/addAccountExpenseEntry',
        async (arg, thunkApi) => {
            const { AccountTaxZoneId, ...argWithoutId } = arg;
            if (AccountTaxZoneId > 0) {
                argWithoutId.AccountTaxZoneId = AccountTaxZoneId;
            }
            const response = await fetchAPI('api/V2/ExpenseSheets/InsertAccountExpenseEntry', 'POST', argWithoutId,
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const addAccountExpenseSheetCopyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/addAccountExpenseSheetCopy',
        async (arg, thunkApi) => {
            const { AccountEmployeeExpenseSheetId } = arg;
            const response = await fetchAPI('api/V2/ExpenseSheets/InsertAccountExpenseSheetCopy/' + arg, 'POST', '',
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const addAccountExpensePerDiemEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/addAccountExpensePerDiemEntry',
        async (arg, thunkApi) => {
            const { accountEmployeeId } = arg;
            const { accountEmployeeExpenseSheetId } = arg;
            const { reimbursementCurrencyId } = arg;
            const { sheetDescription } = arg;
            const { expenseSheetDate } = arg;
            const { perdiemarray } = arg;
            const encodedSheetDescription = sheetDescription.replace(/[^0-9]/g, ' ');
            const sheetArray = {accountEmployeeId:accountEmployeeId,accountEmployeeExpenseSheetId:accountEmployeeExpenseSheetId,reimbursementCurrencyId:reimbursementCurrencyId,sheetDescription:sheetDescription, expenseSheetDate:expenseSheetDate}
            const array = {perdiemarray:perdiemarray,sheetArray:sheetArray}
            const response = await fetchAPI('api/v2/ExpensePolicyPerDiem/AddAccountExpensePerDiemEntries', 'POST', array,
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const UpdatedAccountExpensePerDiemEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/UpdatedAccountExpensePerDiemEntry',
        async (arg, thunkApi) => {
            const { AccountExpenseEntryId } = arg;
            const { expenseRecords } = arg;
            const { expenseSheetDate } = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/UpdatedAccountExpensePerDiemEntry/' + AccountExpenseEntryId, 'PUT', { expenseRecords, expenseSheetDate }, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountExpenseSheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/updateAccountExpenseSheet',
        async (arg, thunkApi) => {
            const { AccountEmployeeExpenseSheetId, ExpenseSheetData } = arg;
            const response = await fetchAPI('api/V2/ExpenseSheets/UpdateExpenseSheetMaster/' + AccountEmployeeExpenseSheetId, 'PUT', ExpenseSheetData, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const updateAccountExpenseEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/updateAccountExpenseEntry',
        async (arg, thunkApi) => {
            const { AccountExpenseEntryId } = thunkApi.getState().expense;
            const { AccountTimeExpenseBillingExpenseId,
                AccountEmployeeExpenseSheetId,
                AccountExpenseEntryGuidId,
                AccountExpensePolicyPerDiemTypeId,
                AccountExpensePolicyPerDiemLocationId,
                AccountEmployeeId, 
                AccountTaxZoneId,
                isCanvasLoader,
                Tax,
                AccountPaymentMethodId,
                ...argWithoutId } = arg;
            if (AccountTaxZoneId > 0) {
                argWithoutId.AccountTaxZoneId = AccountTaxZoneId;
                // argWithoutId.Tax = Tax
            }
            if (AccountPaymentMethodId === 0) {
                argWithoutId.AccountPaymentMethodId = null;
            }else{
                argWithoutId.AccountPaymentMethodId = AccountPaymentMethodId;
            }
            const response = await fetchAPI('api/V2/ExpenseSheets/UpdateAccountExpenseEntry/' + AccountExpenseEntryId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const SubmitExpenseSheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/SubmitExpenseSheet',
        async (arg, thunkApi) => {
            const { AccountEmployeeExpenseSheetId, ExpeseSheetList} = arg;
            const response = await fetchAPI('api/V2/ExpenseSheets/SubmitExpenseSheet/' + AccountEmployeeExpenseSheetId, 'Post', ExpeseSheetList, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteExpenseSheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/deleteExpenseSheet',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpenseSheets/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAllSelectedExpenseSheetsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "expense/deleteAllSelectedExpenseSheets",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpenseSheets/deleteAllSelectedExpenseSheets/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountExpenseEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/deleteAccountExpenseEntry',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpenseSheets/deleteAccountExpenseEntry/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAllSelectedExpenseEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "expense/deleteAllSelectedExpenseEntries",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpenseSheets/deleteAllSelectedExpenseEntriesAsync/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const ExpenseSlice = createSlice({
    name: 'expense',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.expenseSheetList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseSheetList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.expenseSheetList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expenseSheetList.findIndex((item) => item.AccountEmployeeExpenseSheetId == action.payload);
            const newArray = [...state.expenseSheetList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expenseSheetList = newArray;
        },

        checkedAllState: (state) => {
            const newArray = state.expenseSheetList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expenseSheetList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expenseSheetList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expenseSheetList = newArray;
            //state.isAllUnChecked = true;
        },
        checkedEntryState: (state, action) => {
            const currentindex = state.expenseEntryList.findIndex((item) => item.AccountExpenseEntryId == action.payload);
            const newArray = [...state.expenseEntryList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.expenseEntryList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedEntryState: (state, action) => {
            const currentindex = state.expenseEntryList.findIndex((item) => item.AccountExpenseEntryId == action.payload);
            const newArray = [...state.expenseEntryList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expenseEntryList = newArray;
        },
        checkedAllEntryState: (state) => {
            const newArray = state.expenseEntryList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expenseEntryList = newArray;
        },
        unCheckedAllEntryState: (state) => {
            const newArray = state.expenseEntryList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expenseEntryList = newArray;
        },
        setOptionEmployeeNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionEmployeeNameValue = value;
            state.optionEmployeeNameText = label;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        updateAccountEmployeeId: (state, action: PayloadAction<any>) => {
            state.AccountEmployeeId = action.payload;
            state.isLoading = false;
        },
        updateAccountExpenseEntryId: (state, action: PayloadAction<any>) => {
            state.selectedRecord = {};
            state.AccountExpenseEntryId = action.payload;
           
        },
        updateExpenseSheetDate: (state, action: PayloadAction<string>) => {
            state.expensesheetDate = action.payload;
            state.isReload = false;
        },
        updateReimburseCurrencyId: (state, action: PayloadAction<any>) => {
            state.reimburseCurrencyId = action.payload;
        },
        updateExpenseSheetDescription: (state, action: PayloadAction<string>) => {
            state.expenseSheetDescription = action.payload;
            state.isReload = false;
        },
        updateMasterExpenseSheetId: (state, action: PayloadAction<string>) => {
            state.expenseEntryList = [];
            state.MasterEmployeeExpenseSheetId = action.payload;
        },

        updateExpenseSheetListForSearch: (state, action: PayloadAction<string>) => {
            const searchTerm = action.payload; 
            if (searchTerm.length > 0) {
                const filteredData = state.expenseEntryList.filter((item: any) => {
                        const searchTermLowerCase = searchTerm.toLowerCase();
                        return Object.values(item).some((value: any) => {
                            if (typeof value === 'string') {
                                return value.toLowerCase().includes(searchTermLowerCase);
                            }
                            return false;
                        });
                    });               
                state.expenseEntryList = filteredData
            } else {
                const filtered = state.filteredExpenseEntryList.filter((item: any) => {
                    const searchTermLowerCase = searchTerm.toLowerCase();
                    return Object.values(item).some((value: any) => {
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(searchTermLowerCase);
                        }
                        return false;
                    });
                });
                state.expenseEntryList = filtered
            }
         },

         updatePageSize:(state, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
         },   
         updatePageNumber:(state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
         }, 
         updateIsDiscriptionPopup: (state, action: PayloadAction<any>) => {
            state.IsDescriptionPopup = action.payload;
           
        },  

        setPreferenceOptions: (state, action: PayloadAction<{ LockSubmittedRecord: any; LockApprovedRecord: any; DecimalPlaces: any}>) => {
            state.LockSubmittedRecord = action.payload.LockSubmittedRecord;
            state.LockApprovedRecord = action.payload.LockApprovedRecord;
            state.DecimalPlaces = action.payload.DecimalPlaces;
        },  

        updateIsLockButton: (state, action: PayloadAction<any>) => {
            state.LockButton = action.payload;
        }, 

        refreshStatus: (state, action: PayloadAction<any>) => {
            state.LockSubmittedRecord = false
            state.LockApprovedRecord = false
            state.SheetApproved = false
            state.SheetSubmitted = false
            state.LockButton = false            
        },

        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrderExpenseSheet = action.payload.sortOrder;
            state.sortColumnExpenseSheet = action.payload.sortColumn;
        },

        updatePagination:(state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.currentPage = action.payload.currentPage;
            // state.sortOrderExpenseEntries = action.payload.sortOrder;
            // state.sortColumnExpenseEntries = action.payload.sortColumn;
         },
         updateLoadClient: (state, action: PayloadAction<boolean>) => {
            state.loadClient = action.payload;
        },
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeAsync.pending, (state, { payload }) => {
                state.status = 'loading';
            })
            .addCase(getEmployeeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.employeeList = payload;
                
            })
            .addCase(getEmployeeAsync.rejected, (state, { payload }) => {
                state.status = 'failed'
                state.employeeList = [];
            })

            .addCase(getReimburseCurrencyAsync.pending, (state, { payload }) => {
                state.status = 'loading';
            })
            .addCase(getReimburseCurrencyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.reimbursecurrencyList = payload.Data;
            })
            .addCase(getReimburseCurrencyAsync.rejected, (state, { payload }) => {
                state.status = 'failed'
                state.reimbursecurrencyList = [];
            })


            .addCase(getExpenseSheetByAccountEmployeeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getExpenseSheetByAccountEmployeeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.expenseSheetList = Array.isArray(payload.Data) ? payload.Data : [];
                state.expenseSheetList.map((item: any) => {
                    item.isSelected = 0;
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getExpenseSheetByAccountEmployeeIdAsync.rejected, (state) => {

                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isReload = true;
            })
            .addCase(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.expenseSheetMasterList = payload.Data;
                state.isReload = false;
            })
            .addCase(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isReload = false;
            })
            .addCase(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.expenseEntryList = [];
                } else {
                    state.expenseEntryList = payload.Data;
                    state.filteredExpenseEntryList = payload.Data;
                    state.expenseEntryList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isLoading = false;               
                state.isReload = false;               
                state.selectedRecord = {};
            })
            .addCase(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync.rejected, (state) => {
                state.expenseEntryList = [];
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(getCalculationsFieldsByAccountExpenseIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getCalculationsFieldsByAccountExpenseIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
               
            })
            .addCase(getCalculationsFieldsByAccountExpenseIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getCalculateAmountAndReimburseAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getCalculateAmountAndReimburseAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(getCalculateAmountAndReimburseAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(GetExpenseCalculateAmountAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetExpenseCalculateAmountAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';    
            })
            .addCase(GetExpenseCalculateAmountAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(SetDefaultExpenseRateAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(SetDefaultExpenseRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';

            })
            .addCase(SetDefaultExpenseRateAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getExpenseSheetTotalAmountAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getExpenseSheetTotalAmountAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(getExpenseSheetTotalAmountAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getDataByAccountExpenseEntryIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getDataByAccountExpenseEntryIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload[0];

            })
            .addCase(getDataByAccountExpenseEntryIdAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(getAccountExpensePerDiemTypeAndRateAsyc.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountExpensePerDiemTypeAndRateAsyc.fulfilled, (state, { payload }) => {
                state.expensePerdiemList = payload.Data;
                state.status = 'idle';
                state.isReload = false;
            })
            .addCase(getAccountExpensePerDiemTypeAndRateAsyc.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getValidateAccountExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getValidateAccountExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.IsValidatePerDiemPolicy = payload.Data.dtValidateExpensePolicy[0]
                state.status = 'idle';
                state.isReload = false;
            })
            .addCase(getValidateAccountExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(ShowExpenseSheetStatusAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ShowExpenseSheetStatusAsync.fulfilled, (state, { payload }) => {
                state.SheetApproved = payload.Data[0].Approved === true ? payload.Data[0].Approved : false
                state.SheetSubmitted = payload.Data[0].Submitted === true ? payload.Data[0].Submitted : false
                state.status = 'idle';
            })
            .addCase(ShowExpenseSheetStatusAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(GetEmployeeExpenseSheetApprovalDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetEmployeeExpenseSheetApprovalDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.expenseSheetApprovalList = payload.Data;
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(GetEmployeeExpenseSheetApprovalDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(GetSubmittedByAndSubmittedOnAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetSubmittedByAndSubmittedOnAsync.fulfilled, (state, { payload }) => {
                 state.status = 'idle';
                // state.IsSheetSubmitted = payload.Data[0].SubmittedDate;
                if (Object.keys(payload.Data).length === 0) {
                    
                } else {
                    state.IsSheetSubmitted = payload.Data[0].SubmittedDate;
                    state.approvalStatus = payload.Data[0].Status !== 'Not Submitted';
                }  

            })
            .addCase(GetSubmittedByAndSubmittedOnAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(GetDataForExpenseSheetPrintAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GetDataForExpenseSheetPrintAsync.fulfilled, (state, { payload }) => {
                state.MasterData = payload.Data[0][0];
                state.CurrencySymbol = payload?.Data[0][0]?.CurrencyCode;
                state.TotalExpenseAmount = payload?.Data[0][0]?.Amount
                state.DetailsData = payload.Data[1];
                state.SheetDetailForCalculation = payload.Data[2];
                state.ReimburseCurrency = payload.Data[3][0];
                state.ExchangeRate = payload.Data[7];
                state.ImageURL = payload.Data[8];
                state.IsElectronicSignExistInSessionAccount = payload.Data[9];
                state.LogoURL = payload.Data[10];
                state.status = 'idle';
            })
            .addCase(GetDataForExpenseSheetPrintAsync.rejected, (state) => {
                state.status = 'failed';
            })            
            .addCase(getDataForLockExpensePreviuosEntriesAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getDataForLockExpensePreviuosEntriesAsync.fulfilled, (state, { payload }) => {
                // state.LockAllPreviousExpenseEntries = payload.LockAllPreviousExpenseEntries;
                // state.LockAllPreviousMonthsExpenseEntries = payload.LockAllPreviousMonthsExpenseEntries
                state.status = 'idle';                
            })
            .addCase(getDataForLockExpensePreviuosEntriesAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountEmployeeExpenseSheetAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountEmployeeExpenseSheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
            })
            .addCase(addAccountEmployeeExpenseSheetAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountExpensePerDiemEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountExpensePerDiemEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addAccountExpensePerDiemEntryAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountExpenseEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountExpenseEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addAccountExpenseEntryAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountExpenseSheetCopyAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountExpenseSheetCopyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addAccountExpenseSheetCopyAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(UpdatedAccountExpensePerDiemEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(UpdatedAccountExpensePerDiemEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(UpdatedAccountExpensePerDiemEntryAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountExpenseEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountExpenseEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updateAccountExpenseEntryAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountExpenseSheetAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountExpenseSheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.IsDescriptionPopup = false;
            })
            .addCase(updateAccountExpenseSheetAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(submittedTimesheetAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(submittedTimesheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(submittedTimesheetAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteExpenseSheetAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteExpenseSheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteExpenseSheetAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAllSelectedExpenseSheetsAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedExpenseSheetsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedExpenseSheetsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(deleteAccountExpenseEntryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountExpenseEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteAccountExpenseEntryAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllSelectedExpenseEntriesAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedExpenseEntriesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedExpenseEntriesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

          

    }
})
export const {
    resetSelectedRecordObjectInState,
    checkedState,
    unCheckedState,
    checkedAllState,
    unCheckedAllState,
    checkedEntryState,
    unCheckedEntryState,
    checkedAllEntryState,
    unCheckedAllEntryState,
    setOptionEmployeeNameValue,
    updateIsCanvasLoading,
    setDateRangeValue,
    updateAccountEmployeeId,
    updateAccountExpenseEntryId,
    updateExpenseSheetDate,
    updateReimburseCurrencyId,
    updateExpenseSheetDescription,
    updateMasterExpenseSheetId,
    updateExpenseSheetListForSearch,
    updatePageSize,
    updatePageNumber,updateIsDiscriptionPopup,
    setPreferenceOptions,
    updateIsLockButton,
    refreshStatus,
    updateSorting,
    updatePagination,
    updateLoadClient
} = ExpenseSlice.actions
export const expenseStateClass = (state: RootState) => state.expense
export default ExpenseSlice.reducer